export default {
  ABOUT: '64fb22dd-a6f6-4d65-bdd9-1c55740dc5aa',
};
